import React from "react";
import ResorcesIntro from "./ResorcesIntro";
import ResourceList from "./ResourceList";

const Resources = () => {

    return (
        <div className="resource-header font-figtree">
            <ResorcesIntro />
            <ResourceList />
        </div>
    );
};

export default Resources;